import Event from "./Event";
export default class EventProgrammed extends Event {
	constructor(data) {
		super(data);
		this.activity_name = data.activity_name || "";
		this.address = data.address || "";
		this.batch_event_id = data.batch_event_id || 0;
		this.city = data.city || "";
		this.company_id = data.company_id || 0;
		this.country = data.country || "";
		this.cx = data.cx || 0;
		this.cy = data.cy || 0;
		this.date_prog = data.date_prog || "";
		this.day_of_week = data.day_of_week || 0;
		this.department = data.department || "";
		this.end_address = data.end_address || null;
		this.end_city = data.end_city || null;
		this.end_cx = data.end_cx || 0;
		this.end_cy = data.end_cy || 0;
		this.event_end_hour = data.event_end_hour || null;
		this.event_init_hour = data.event_init_hour || null;
		this.in_event_status = data.in_event_status || null;
		this.init_address = data.init_address || null;
		this.init_city = data.init_city || null;
		this.init_cx = data.init_cx || 0;
		this.init_cy = data.init_cy || 0;
		this.message = data.message || null;
		this.name_day_of_week = data.name_day_of_week || "";
		this.recipients = data.recipients || null;
		this.username = data.username || "";
		this.visit_point_name = data.visit_point_name || "";
	}
}
